import { CMSPageSection, CMSSectionBlocksStrategy } from "src/api/client-api/cms/useGetOneContent";

type StrategyIndicatorsProps = {
    section: CMSPageSection<CMSSectionBlocksStrategy>;
};
export const StrategyIndicators = (props: StrategyIndicatorsProps) => {
    return <></>;
};
